import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const CONDITIONS_STEP_SKELETON_FIELD_CARDS = [2, 1, 1]

export const ConditionsStepSkeleton = () => (
  <>
    {CONDITIONS_STEP_SKELETON_FIELD_CARDS.map((fieldsCount, cardIndex) => (
      <div
        key={cardIndex}
        className={s.card}
      >
        <Skeleton
          className={s.title}
          borderRadius={6}
        />

        {Array.from({ length: fieldsCount }).map((_, fieldIndex) => (
          <Skeleton
            key={fieldIndex}
            className={s.field}
          />
        ))}
      </div>
    ))}

    <div className={s.card}>
      <Skeleton
        className={s.title}
        borderRadius={6}
      />
      <Skeleton className={s.textareaField} />
    </div>
  </>
)
